import { render, staticRenderFns } from "./atlas_wx.vue?vue&type=template&id=07d3f3fa&scoped=true"
import script from "./atlas_wx.vue?vue&type=script&lang=js"
export * from "./atlas_wx.vue?vue&type=script&lang=js"
import style0 from "./atlas_wx.vue?vue&type=style&index=0&id=07d3f3fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3f3fa",
  null
  
)

export default component.exports